import { Action, createReducer, on } from '@ngrx/store';
import { LocalStorageService } from 'src/app/shared/localstorage.service';
import { normalizePermissionNames } from './permissions.catalog';
import * as permissionsActions from './permissions.actions';

export interface PermissionsState {
  permissions: string[];
  loaded: boolean;
}

export function createInitialPermissionsState(): PermissionsState {
  const storedCurrentUser = LocalStorageService.get('currentUser');
  return {
    permissions: normalizePermissionNames(
      storedCurrentUser?.user?.permissions ?? []
    ),
    loaded: false,
  };
}

const permissionsFeatureReducer = createReducer(
  createInitialPermissionsState(),
  on(permissionsActions.loadPermissionsFromLogin, (_state, { permissions }) => ({
    permissions: normalizePermissionNames(permissions),
    loaded: true,
  })),
  on(permissionsActions.refreshPermissionsSuccess, (_state, { permissions }) => ({
    permissions: normalizePermissionNames(permissions),
    loaded: true,
  })),
  on(permissionsActions.refreshPermissionsFailure, () => ({
    permissions: [],
    loaded: false,
  })),
  on(permissionsActions.clearPermissions, () => ({
    permissions: [],
    loaded: false,
  }))
);

export function permissionsReducer(
  state: PermissionsState | undefined,
  action: Action
): PermissionsState {
  return permissionsFeatureReducer(state, action);
}
